import { StudentWrongQuestionList } from './StudentWrongQuestionList';
export default StudentWrongQuestionList;